import { FC } from 'react';
import MenuItem from '@/components/menu/menu-item';
import Divider from '@mui/material/Divider';
import { UpdateMenuItemProps } from './helpers';

const UpdateMenuItems: FC<Omit<UpdateMenuItemProps, 'showUpdateMenu'>> = ({
  onEdit,
  onDelete,
  canEdit,
  canDelete,
  editSubtitle,
  deleteSubtitle,
}) => {
  const hasEdit = !!onEdit;
  const hasDelete = !!onDelete;
  if (!hasEdit && !hasDelete) {
    // This generally should not happen, but handling in case
    return null;
  }

  return (
    <>
      <Divider />
      {hasEdit && (
        <MenuItem
          onClick={onEdit}
          label="Edit"
          subtitle={editSubtitle}
          disabled={!canEdit}
          icon="edit"
        />
      )}
      {hasDelete && (
        <MenuItem
          onClick={onDelete}
          label="Delete"
          subtitle={deleteSubtitle}
          disabled={!canDelete}
          icon="delete"
          color="error"
        />
      )}
    </>
  );
};

export default UpdateMenuItems;
